import { render } from "./PopupDeleteAchievement.vue?vue&type=template&id=d6139ab8"
import script from "./PopupDeleteAchievement.vue?vue&type=script&lang=js"
export * from "./PopupDeleteAchievement.vue?vue&type=script&lang=js"

import "./PopupDeleteAchievement.vue?vue&type=style&index=0&id=d6139ab8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__